import React from 'react';
import PropTypes from 'prop-types';

import { ALBUM_SUBTYPE } from '../../../../../../constants/albums';
import BirthdayEventDetails from './components/BirthdayEventDetails';
import AnniversaryEventDetails from './components/AnniversaryEventDetails';
import GraduationEventDetails from './components/GraduationEventDetails';
import MemorialEventDetails from './components/MemorialEventDetails';
import VacationEventDetails from './components/VacationEventDetails';
import FundraiserEventDetails from './components/FundraiserEventDetails';
import CustomEventDetails from './components/CustomEventDetails';
import WeddingEventDetails from './components/WeddingEventDetails';
import { EVENT_DETAILS_CONTEXT } from './utils';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email_address: PropTypes.string,
  }),
  values: PropTypes.shape({
    name: PropTypes.string,
    date: PropTypes.object,
  }).isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  eventType: PropTypes.string,
  requireAccountEmail: PropTypes.bool,
  requireCouplesEmail: PropTypes.bool,
  allowAutoComplete: PropTypes.bool,
  context: PropTypes.oneOf(Object.values(EVENT_DETAILS_CONTEXT)),
  includeCelebrated: PropTypes.bool,
};

const FreemiumEventDetails = ({
  user,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  eventType,
  requireAccountEmail,
  requireCouplesEmail,
  allowAutoComplete = true,
  context,
  includeCelebrated = true,
}) => {
  switch (eventType) {
    case ALBUM_SUBTYPE.BIRTHDAYS:
      return (
        <BirthdayEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          context={context}
        />
      );
    case ALBUM_SUBTYPE.ANNIVERSARIES:
      return (
        <AnniversaryEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          context={context}
        />
      );
    case ALBUM_SUBTYPE.GRADUATIONS:
      return (
        <GraduationEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          context={context}
        />
      );
    case ALBUM_SUBTYPE.MEMORIALS:
      return (
        <MemorialEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          context={context}
        />
      );
    case ALBUM_SUBTYPE.VACATIONS:
      return (
        <VacationEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          context={context}
        />
      );
    case ALBUM_SUBTYPE.FUNDRAISERS:
      return (
        <FundraiserEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          context={context}
        />
      );
    case ALBUM_SUBTYPE.WEDDINGS:
      return (
        <WeddingEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          requireAccountEmail={requireAccountEmail}
          requireCouplesEmail={requireCouplesEmail}
          allowAutoComplete={allowAutoComplete}
          context={context}
        />
      );
    default:
      return (
        <CustomEventDetails
          user={user}
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          context={context}
          includeCelebrated={includeCelebrated}
        />
      );
  }
};

FreemiumEventDetails.propTypes = propTypes;

export { FreemiumEventDetails as EventShutterbugDetailsComp };

export default FreemiumEventDetails;
